<template>
  <div class="radio-group">
    <ui-radio
      v-for="(option, i) in options"
      :key="i"
      :model-value="modelValue"
      :option="option.value"
      :label="option.label"
      :name="name"
      :error="errorMode"
      :caption="option.caption"
      @click="onClick(option.value)"
    >
      <slot :option="option" />
    </ui-radio>
  </div>
</template>

<script>
export default {
  name: 'radio-group',

  props: {
    modelValue: {
      type: [String, Number],
      default: '',
    },

    options: {
      type: Array,
      required: true,
    },

    name: {
      type: String,
      required: true,
    },

    errorMode: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    onClick(val) {
      this.$emit('update:modelValue', val);
    },
  },
};
</script>

<style lang="scss">
.radio-group {
  .ui-radio {
    margin-top: 16px;
  }
}
</style>
